import { createTheme } from '@mui/material/styles';
const typographyOptions = {
    fontFamily: ['serif'].join(','),
};
const BaseThemeOptions = {
    components: {
        MuiAutocomplete: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiButton: {
            defaultProps: {
                size: 'small',
                variant: 'contained',
            },
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    paddingTop: 0,
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                title: {
                    fontSize: '1.3rem',
                },
                subheader: {
                    fontSize: '0.9rem',
                },
            },
        },
        MuiChip: {
            defaultProps: {
                variant: 'outlined',
                size: 'small',
            },
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        opacity: 0.9,
                    },
                },
            },
        },
        MuiCheckbox: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiIconButton: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiInputBase: {
            defaultProps: {
                size: 'small',
            },
            styleOverrides: {
                root: {
                    fontSize: '1rem !important',
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    paddingLeft: 0,
                    paddingRight: 0,
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    background: 'rgba(0,0,0,0)',
                },
            },
        },
        MuiTable: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiTablePagination: {
            styleOverrides: {
                toolbar: {
                    minHeight: '0 !important',
                },
                displayedRows: {
                    opacity: 0.75,
                    fontSize: '0.75rem',
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                size: 'small',
                variant: 'standard',
                InputLabelProps: { shrink: true },
            },
        },
        MuiToggleButtonGroup: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiToggleButton: {
            defaultProps: {
                size: 'small',
            },
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        // Fix for an issue where useMediaQuery always returns false at the first call
        // https://github.com/mui-org/material-ui/issues/21142
        MuiUseMediaQuery: {
            defaultProps: {
                noSsr: true,
            },
        },
    },
};
export const DefaultTheme = createTheme({
    typography: typographyOptions,
    palette: {
        mode: 'light',
        primary: {
            light: '#ada695',
            main: '#7E7767',
            dark: '#524b3d',
            contrastText: '#fff',
        },
        secondary: {
            main: '#f50057',
        },
        background: {
            default: 'rgba(0,0,0,0)',
            paper: 'rgba(255,255,255,0.9)',
        },
        text: {
            disabled: 'rgba(0,0,0,0.8)',
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#393a3d88',
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    background: 'linear-gradient(to right, #ffffff, #bdc3c7)',
                },
            },
        },
    },
}, BaseThemeOptions);
export const DarkTheme = createTheme({
    typography: typographyOptions,
    palette: {
        mode: 'dark',
        primary: {
            light: '#b3d8ff',
            main: '#80A7EF',
            dark: '#4c78bc',
            contrastText: '#000',
        },
        error: {
            light: '#ff7970',
            main: '#EA4444',
            dark: '#b1001c',
            contrastText: '#000',
        },
        success: {
            light: '#88fb84',
            main: '#52C755',
            dark: '#049526',
            contrastText: '#000',
        },
        warning: {
            light: '#ffe673',
            main: '#FFB442',
            dark: '#c78403',
            contrastText: '#000',
        },
        text: {
            disabled: 'rgba(255,255,255,0.8)',
        },
        background: {
            default: 'rgba(0,0,0,0)',
            paper: 'rgba(0,0,0,0.8)',
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    background: 'linear-gradient(to right, #536976, #292e49)',
                },
            },
        },
    },
}, BaseThemeOptions);
